<template><!-- svgo-optimised -->
<svg  class="icon icon__cart" width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M14 4H1V16H14V4Z" stroke="currentColor" stroke-miterlimit="10"/>
  <path d="M11 7V4.5C11 2.567 9.433 1 7.5 1V1C5.567 1 4 2.567 4 4.5V7" stroke="currentColor"/>
</svg>
</template>